import Reserves from '../components/Exportation/Reserves'
import Users from '../components/Exportation/Users'
import Requests from '../components/Exportation/Requests'
import Divergences from '../components/Exportation/Divergences'
import Vehicles from '../components/Exportation/Vehicles'
import VehicleTypes from '../components/Exportation/VehicleTypes'
import Categories from '../components/Exportation/Categories'
import Departments from '../components/Exportation/Departments'
import Branches from '../components/Exportation/Branches'
import Justifications from '../components/Exportation/Justifications'
import Colors from '../components/Exportation/Colors'
import Cities from '../components/Exportation/Cities'

let routes = {
    path: '/exportation',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/exportation/reserves',
            name: 'Exportação - Reservas',
            component: Reserves
        },
        {
            path: '/exportation/users',
            name: 'Exportação - Usuários',
            component: Users
        },
        {
            path: '/exportation/requests_history',
            name: 'Exportação - Histórico de Consultas',
            component: Requests
        },
        {
            path: '/exportation/divergences',
            name: 'Exportação - Não conformidades',
            component: Divergences
        },
        {
            path: '/exportation/vehicles',
            name: 'Exportação - Veículos',
            component: Vehicles
        },
        {
            path: '/exportation/vehiclesTypes',
            name: 'Exportação - Tipo de Veículos',
            component: VehicleTypes
        },
        {
            path: '/exportation/categories',
            name: 'Exportação - Categorias',
            component: Categories
        },
        {
            path: '/exportation/departments',
            name: 'Exportação - Centros de Custo',
            component: Departments
        },
        {
            path: '/exportation/branches',
            name: 'Exportação - Filiais',
            component: Branches
        },
        {
            path: '/exportation/justifications',
            name: 'Exportação - Justificativa de Reserva',
            component: Justifications
        },
        {
            path: '/exportation/colors',
            name: 'Exportação - Cores',
            component: Colors
        },
        {
            path: '/exportation/cities',
            name: 'Exportação - Cidades',
            component: Cities
        },
    ]
};

export default routes



// WEBPACK FOOTER //
// ./src/router/exportation.js